import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


export interface TerminateFieldWorkerDialogData {
	fieldWorkerId: number
}

@Component({
	selector: 'rpfsa-add-field-worker-terminated-dialog',
	templateUrl: './terminate-field-worker-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TerminateFieldWorkerDialogComponent {
	constructor(
		private dialogRef: MatDialogRef<TerminateFieldWorkerDialogComponent>,
	) {}

	cancel() {
		this.dialogRef.close(false);
	}

	accept() {
		this.dialogRef.close(true);
	}
}
